import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Claim.SetStatus.IRequest;
type Response = Api.Core.Claim.SetStatus.IResponse;
type Headers = Api.Core.Claim.SetStatus.IHeaders;
const url = '/api/Claims/Claim/SetStatus';
export default async function claimSetStatusApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
